import Alpine from "alpinejs";

interface menu {
  isOpen: boolean;
  closeMenu: () => void;
  closeOnDesktop: () => void;
  toggleMenu: () => void;
}
export const menu = () => {
  Alpine.store("menu", {
    isOpen: false, // ham menuの開閉チェック

    /**
     * Ham Menu の On/Off
     */
    closeMenu() {
      this.isOpen = false;
      document.body.style.overflow = "";
    },

    closeOnDesktop() {
      if (window.innerWidth >= 768 && this.isOpen) {
        this.closeMenu();
      }
    },

    toggleMenu() {
      this.isOpen = !this.isOpen;
      document.body.style.overflow = this.isOpen ? "hidden" : "";
    },
  } as menu);
};
